import { Fragment, useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch"
import TextArea from "../../../../ui/molecules/textArea"
import { GetByIdPersonalManagement } from "../../slice"
import { OtherDataUpdate, OtherDataValidation, resetOtherDataErrors, resetOtherDataUpdateRequest, resetOtherDataUpdateStatus, resetOtherDataValidationStatus, setUpdateOtherDataCommitmentStatement, setUpdateOtherDataProtocolIdEntry } from "../slice"

interface Props {
    close: () => void;
}

export function OtherDataPopupEdit(props: Props) {
    const dispatch = useAppDispatch()
    const otherDataState = useAppSelector(state => state.PMOtherData)
    const PMState = useAppSelector(state => state.personalManagement)

    useEffect(() => {
        if (otherDataState.otherDataValidationStatus === 'successfully') {
            dispatch(resetOtherDataValidationStatus())
            dispatch(resetOtherDataErrors())
            dispatch(OtherDataUpdate({ body: otherDataState.otherDataUpdateRequest, id: otherDataState.otherDataIdToUpdate }))
        }
    }, [otherDataState.otherDataValidationStatus])

    useEffect(() => {
        if (otherDataState.otherDataUpdateStatus === 'successfully') {
            dispatch(resetOtherDataUpdateStatus())
            dispatch(resetOtherDataUpdateRequest())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
            props.close()
        }
    }, [otherDataState.otherDataUpdateStatus])

    return (
        <Fragment>
            <div className="p-6 bg-white flex flex-col gap-6">

                <div className="grid grid-cols-1 gap-6">
                    <ProtocolSearch
                        type="entry"
                        defaultValue={otherDataState.otherDataUpdateRequest.protocolIdEntry}
                        onSelect={(value) => dispatch(setUpdateOtherDataProtocolIdEntry(value))}
                    />
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <TextArea
                        label="Note"
                        error={otherDataState.otherDataErrors.commitmentStatement}
                        supportingText={otherDataState.otherDataErrors.commitmentStatement ? 'Note mancanti' : undefined}
                        defaultValue={otherDataState.otherDataUpdateRequest.commitmentStatement}
                        value={otherDataState.otherDataUpdateRequest.commitmentStatement}
                        onChangeText={(text) => dispatch(setUpdateOtherDataCommitmentStatement(text))}
                    />
                </div>

                <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="gray"
                        onClick={() => {
                            dispatch(resetOtherDataErrors())
                            dispatch(resetOtherDataUpdateRequest())
                            props.close()
                        }}
                    />
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => {
                            dispatch(OtherDataValidation(otherDataState.otherDataUpdateRequest))
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}